import React from 'react'; 
import { Menu } from 'primereact/menu';
import { useLocation } from 'react-router-dom';

export default function TemplateDemo() {
    const location = useLocation();

    let items = [
        {
            template: () => {
                return (
                    <span className="inline-flex align-items-center gap-1 px-2 py-2">
                        <i className='pi pi-chart-bar'></i>
                        &nbsp;
                        <span className="font-medium text-xl font-semibold">
                            GeoRank<span className="text-primary">Insights</span>
                        </span>
                    </span>
                );
            }
        },
        {
            separator: true
        },
        {
            label: 'Players',
            items: [
                {
                    label: 'Players of the day',
                    icon: 'pi pi-trophy',
                    url: '/insights/playersOfTheDay'
                },
                {
                    label: 'Players of the week',
                    icon: 'pi pi-calendar',
                    url: '/insights/playersOfTheWeek'
                }
                // ,
                // {
                //     label: 'Top 30 daily highlights',
                //     icon: 'pi pi-sparkles',
                // }
            ].map((item) => ({
                ...item,
                className: (location.pathname === item.url || item?.items?.find(item=>item.url === location.pathname)) ? "p-focus" : ""
            }))
        }
        // ,
        // {
        //     label: 'Your insights',
        //     items: [
        //         {
        //             label: 'Where you\'d be a star?',
        //             icon: 'pi pi-star',
        //         },
        //         {
        //             label: 'You vs Country',
        //             icon: 'pi pi-inbox',
        //         }
        //     ]
        // },
        // {
        //     separator: true
        // }
    ];

    return (
        <div className="card flex justify-content-center">
            <Menu model={items} className="w-full md:w-15rem" />
        </div>
    )
}
        